import { Theme, ThemeProvider } from '@mui/material';
import { PropsWithChildren, useMemo, useState } from 'react';

import 'jetbrains-mono';
import './index.css';

import { darkTheme } from './dark-theme';
import { lightTheme } from './light-theme';
import { ThemeContext, ThemeNameType } from './ThemeContext';

const themes: Record<ThemeNameType, Theme> = {
  dark: darkTheme,
  light: lightTheme,
};

export const ThemeConnector = ({ children }: PropsWithChildren) => {
  const [selectedTheme, setSelectedTheme] = useState<ThemeNameType>('dark');
  const ctx = useMemo(
    () => ({
      selectedTheme,
      setSelectedTheme,
    }),
    [selectedTheme],
  );
  return (
    <ThemeContext.Provider value={ctx}>
      <ThemeProvider theme={themes[selectedTheme]}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};
